import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const WarningIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faExclamationTriangle} color={props.color || 'black'} />
  )
}
